import { styled, Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import React from 'react';

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
}));

CustomTooltip.displayName = 'CustomTooltip';
export default CustomTooltip;
